import React from 'react';
import Aux from './../../../hoc/_Aux';

import * as constantArticle from './../../../conf/constantArticle';

// Bloc de remplissage "bouchon"
const FillingBloc = (props) => {

    let blocOutput = null;
    let blocPosition = (props.position==="left" || props.position==="right")?"col-"+props.position:"";
    let blocClass = ['article', 'bloc-bouchon'];
    let blocStyle = {
        'background': (typeof props.background!==undefined)?props.background:'transparent',
    }
    let titleStyle = {
        'color': (typeof props.titleColor!==undefined)?props.titleColor:'#000',
    }                

    if(props.blocType===constantArticle.BLOC_BOUCHON_EARN_POINTS){
        blocClass.push(blocPosition);
        blocClass.push('earn-points');
        blocOutput = (
            <div className={blocClass.join(' ')} 
                 style={blocStyle}
                 onClick={() => props.blocClicked(props.link)} >

                    <h3 style={titleStyle}>{props.title}</h3>
            </div>
        );
    }else if(props.blocType===constantArticle.BLOC_BOUCHON_LAST_EDITION){
        blocClass.push(blocPosition);
        blocClass.push('last-edition');
        blocOutput = (
            <div className={blocClass.join(' ')} 
                 style={blocStyle}
                 onClick={() => props.blockClicked(props.link)} >
                    
                    <h3 style={titleStyle}>{props.title}</h3>
            </div>
        );
    }

    

    return(
        <Aux>
            {blocOutput}
        </Aux> 

    )
}

export default FillingBloc;


// WEBPACK FOOTER //
// ./src/containers/Article/FillingBloc/FillingBloc.js